// ── DYNAMIC MULTI-STEP LENS FINDER ────────────────
const quizContainer = document.getElementById('sleepzm-lens-finder');

if (quizContainer) {
  const steps = quizContainer.querySelectorAll('.quiz-step');
  const startBtn = quizContainer.querySelector('.start-quiz-btn');
  const answerBtns = quizContainer.querySelectorAll('.answer-btn');
  const resetBtns = quizContainer.querySelectorAll('.reset-quiz-btn');
  const resultScreen = document.getElementById('quiz-result-screen');

  // Load the lens data
  const lensDatabase = JSON.parse(
    document.getElementById('lens-database').textContent
  );

  let userTags = []; // This remembers what the user clicks

  function goToStep(stepIndex) {
    steps.forEach(step => step.classList.remove('is-active'));
    resultScreen.classList.remove('is-active');

    const nextStep = quizContainer.querySelector(
      `[data-step="${stepIndex}"]`
    );

    // If there's no next step, the quiz is over. Show results.
    if (!nextStep && stepIndex !== 0) {
      calculateResult();
    } else if (nextStep) {
      nextStep.classList.add('is-active');
    }
  }

  function calculateResult() {
    let bestMatch = lensDatabase[0];
    let highestScore = 0;

    // Loop through lenses and count how many tags
    // match the user's answers
    lensDatabase.forEach(lens => {
      let score = 0;

      lens.tags.forEach(tag => {
        if (userTags.includes(tag)) {
          score++;
        }
      });

      if (score > highestScore) {
        highestScore = score;
        bestMatch = lens;
      }
    });

    // Populate and show results
    document.getElementById('quiz-recommended-lens').textContent =
      bestMatch.name;

    document.getElementById('quiz-recommended-desc').textContent =
      bestMatch.desc;

    document.getElementById('quiz-result-link').href =
      bestMatch.url;

    resultScreen.classList.add('is-active');
  }

  if (startBtn) {
    startBtn.addEventListener('click', () => {
      goToStep(1);
    });
  }

  answerBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      // Save the tag from this answer
      const tag = this.getAttribute('data-tag');

      if (tag) {
        userTags.push(tag);
      }

      // Move to the next step
      const nextStep = this.getAttribute('data-target-step');

      goToStep(nextStep);
    });
  });

  resetBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      userTags = []; // Clear memory

      goToStep(0);
    });
  });
}


// ── CART / ADD TO CART ─────────────────────────────

document.addEventListener('DOMContentLoaded', function () {

  // ─────────────────────────────────────────────────
  // PART 1: HIJACK THE HEADER CART ICON
  // ─────────────────────────────────────────────────

  const cartLinks = document.querySelectorAll(
    'a[href="/cart"], .header__cart'
  );

  cartLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      window.ShopifyCartDrawer.open();
    });
  });


  // ─────────────────────────────────────────────────
  // PART 2: HIJACK THE ADD TO CART BUTTONS
  // ─────────────────────────────────────────────────
  //
  // IMPORTANT:
  // Collection Quick Add forms use [data-quick-add-form]
  // and are already handled by main-collection.liquid.
  //
  // We MUST exclude them here so the same product is not
  // added twice.
  // ─────────────────────────────────────────────────

  document.body.addEventListener('submit', function (e) {
    const form = e.target;

    if (
      form.action &&
      form.action.includes('/cart/add') &&
      !form.matches('[data-quick-add-form]')
    ) {
      e.preventDefault();

      const submitBtn = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      );

      let originalText = '';

      if (submitBtn) {
        originalText = submitBtn.innerHTML;

        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
      }

      const formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error adding to cart');
          }

          return response.json();
        })

        // Fetch the entire current URL so we get
        // the freshest cart/header data
        .then(item => {
          return fetch(window.location.href);
        })

        .then(res => res.text())

        .then(html => {
          const parsedHTML = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          // ───────────────────────────────────────────
          // 1. UPDATE THE DRAWER CONTENT
          // ───────────────────────────────────────────

          const newDrawerBody =
            parsedHTML.getElementById('CartDrawer-Body');

          const newSubtotal =
            parsedHTML.getElementById('cart-subtotal');

          const newCount =
            parsedHTML.getElementById('cart-count');

          const currentDrawerBody =
            document.getElementById('CartDrawer-Body');

          const currentSubtotal =
            document.getElementById('cart-subtotal');

          const currentCount =
            document.getElementById('cart-count');

          if (newDrawerBody && currentDrawerBody) {
            currentDrawerBody.innerHTML =
              newDrawerBody.innerHTML;
          }

          if (newSubtotal && currentSubtotal) {
            currentSubtotal.innerHTML =
              newSubtotal.innerHTML;
          }

          if (newCount && currentCount) {
            currentCount.innerHTML =
              newCount.innerHTML;
          }


          // ───────────────────────────────────────────
          // 2. BULLETPROOF HEADER UPDATE
          // ───────────────────────────────────────────

          // Find every cart link on the page and replace
          // its contents with the fresh server data

          const currentCartLinks =
            document.querySelectorAll('a[href="/cart"]');

          const freshCartLinks =
            parsedHTML.querySelectorAll('a[href="/cart"]');

          currentCartLinks.forEach((link, index) => {
            if (freshCartLinks[index]) {
              link.innerHTML =
                freshCartLinks[index].innerHTML;
            }
          });


          // ───────────────────────────────────────────
          // 3. RESTORE THE ADD TO CART BUTTON
          // ───────────────────────────────────────────

          if (submitBtn) {
            submitBtn.innerHTML = originalText;

            submitBtn.classList.remove('is-loading');

            submitBtn.disabled = false;
          }


          // ───────────────────────────────────────────
          // 4. OPEN THE CART DRAWER
          // ───────────────────────────────────────────

          window.ShopifyCartDrawer.open();
        })

        .catch(error => {
          console.error('AJAX Cart Error:', error);

          window.location.href = '/cart';
        });
    }
  });
});